// First-time visit tracking utility
// Manages localStorage to track which pages the user has visited before

import { shouldAutoStartTours } from "./userPreferences";

const STORAGE_KEY = "trackingTool_visitedPages";

// Get all visited pages from localStorage
export const getVisitedPages = () => {
	try {
		const visited = localStorage.getItem(STORAGE_KEY);
		return visited ? JSON.parse(visited) : {};
	} catch (error) {
		console.error("Error reading visited pages from localStorage:", error);
		return {};
	}
};

// Check if a specific page has been visited before
export const hasVisitedPage = (pageName) => {
	const visitedPages = getVisitedPages();
	return !!visitedPages[pageName];
};

// Mark a page as visited
export const markPageAsVisited = (pageName) => {
	try {
		const visitedPages = getVisitedPages();
		visitedPages[pageName] = {
			firstVisit: new Date().toISOString(),
			visitCount: (visitedPages[pageName]?.visitCount || 0) + 1,
			lastVisit: new Date().toISOString(),
		};
		localStorage.setItem(STORAGE_KEY, JSON.stringify(visitedPages));
		return true;
	} catch (error) {
		console.error("Error saving visited page to localStorage:", error);
		return false;
	}
};

// Reset all visited pages (for testing or user preference)
export const resetVisitedPages = () => {
	try {
		localStorage.removeItem(STORAGE_KEY);
		return true;
	} catch (error) {
		console.error("Error clearing visited pages from localStorage:", error);
		return false;
	}
};

// Get visit statistics for a specific page
export const getPageVisitStats = (pageName) => {
	const visitedPages = getVisitedPages();
	return visitedPages[pageName] || null;
};

// Page names constants to avoid typos
export const PAGE_NAMES = {
	LANDING: "landing",
	MAINSCREEN: "mainscreen", // Added alias for landing page
	SUPPLY_TYPE: "supplyType",
	VFF: "vff",
	SERIES: "series",
	DASHBOARD: "dashboard",
};

// Check if user should see the tour for a specific page
export const shouldShowTour = (pageName) => {
	// Check if tours are enabled in user preferences
	if (!shouldAutoStartTours()) {
		return false;
	}
	return !hasVisitedPage(pageName);
};

// Mark tour as completed for a page
export const markTourCompleted = (pageName) => {
	markPageAsVisited(pageName);
};
